import script from "./hotProject.vue?vue&type=script&setup=true&lang=js"
export * from "./hotProject.vue?vue&type=script&setup=true&lang=js"

import "./hotProject.vue?vue&type=style&index=0&id=dadcaabe&lang=scss&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dadcaabe"]])

export default __exports__